import { createContext, useContext, type ReactNode } from 'react';
import type { Me } from '../api/types';

const MeCtx = createContext<Me | null>(null);

export function MeProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <MeCtx.Provider value={me}>{children}</MeCtx.Provider>;
}

export function useMeContext(): Me {
  const me = useContext(MeCtx);
  if (!me) throw new Error('MeProvider отсутствует выше по дереву');
  return me;
}

/** Пояс центра: единственный допустимый пояс для вывода дат и времени. */
export function useTz(): string {
  return useMeContext().center.tz;
}

/**
 * Можно ли что-то создавать и менять. `readOnly: true` — подписка центра
 * приостановлена: просмотр остаётся, действия записи блокируются. Проверка
 * на фронте — удобство: сервер всё равно ответит SUBSCRIPTION_READONLY.
 */
export function useWritable(): boolean {
  return !useMeContext().readOnly;
}
